<template>
  <div class="section section-download" id="#download-section" data-background-color="black">
    <div class="container-fluid">
      <div class="row text-center">
        <div class="col-md-11 ml-auto mr-auto">
          <h2>Contacto</h2>
          <h5 class="description">
            <div class="row mb-2">
              <div class="col-md-4 form-group mx-auto mb-3 mb-md-0">
                <img src="@/assets/maps.png" width="23" height="23" class="mr-1" style="margin-top: -6px">
                <a href="https://maps.app.goo.gl/9GXDrkg2dpqJyLxN8" target="_blank">Limón Mz 006, 54602 San Mateo Xoloc, Méx</a>
              </div>
              <div class="col-md-4 form-group mx-auto mb-3 mb-md-0">
                <img src="@/assets/llamada.png" width="23" height="23" class="mr-1" style="margin-top: -6px">
                <a href="tel:+525557192833" target="_blank">55 5719 2833</a>
              </div>
              <div class="col-md-4 form-group mx-auto mb-3 mb-md-0">
                <img src="@/assets/web.png" width="23" height="23" class="mr-1" style="margin-top: -6px">
                <a href="http://www.romidamx.com" target="_blank">www.romidamx.com</a>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-4 form-group mx-auto mb-3 mb-md-0">
                <img src="@/assets/gmail.png" width="23" height="23" class="mr-1" style="margin-top: -6px">
                <a href="https://mail.google.com/mail/?view=cm&fs=1&to=soporte@romida.com.mx" target="_blank">soporte@romida.com.mx</a>
              </div>
              <div class="col-md-4 form-group mx-auto mb-3 mb-md-0">
                <img src="@/assets/instagram.png" width="23" height="23" class="mr-1" style="margin-top: -6px">
                <a href="https://www.instagram.com/romidamx?igsh=a3pnZWY2OWZmNGUx" target="_blank">romidamx</a>
              </div>
              <div class="col-md-4 form-group mx-auto mb-3 mb-md-0">
                <img src="@/assets/linkedin.png" width="23" height="23" class="mr-1" style="margin-top: -6px">
                <a href="https://mx.linkedin.com/company/romidamx" target="_blank">ROMIDA Automation</a>
              </div>
            </div>
          </h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style></style>
